module.exports = __webpack_public_path__ + "img/flota.332d5606.svg";